<template>
    <div style="height:33.5rem;" class="flex items-center">
    <div class="w-1/4 h-full p-6 mt-3 ml-3 shadow-lg bg-gray-50 " >

            <div @click="doScan" class="flex items-center justify-center h-16 text-white bg-yellow-500 rounded-lg shadow-lg cursor-pointer select-none w-44 active:bg-yellow-700">
                <i class="iconfont icon-saoma" style="font-size:20pt;"></i>
                <span class="pl-1 text-lg">识别会员卡</span>
            </div>
<el-divider></el-divider>
            <div v-if="card.card_id!='' && card.card_id!=undefined">
                <p class="leading-none" style="margin-left:-0.5rem;">
                  <i class="iconfont icon-huiyuanqiagoumai" style="font-size:50pt;color:#909090;"></i>
                </p>
                <p class="mb-3">
                  <span class="text-base text-gray-400">卡号</span>
                  <span class="pl-3 text-lg">{{card.card_code}}</span>
                </p>
                  <p class="mb-3">
          <span class="text-base text-gray-400">电子券</span>
          <span class="pl-3 text-lg">{{ card.balance_coupon }}</span>
          <span class="pl-1 text-xs">张</span>
        </p>
                  <p class="mb-3">
                  <span class="text-base text-gray-400">状态</span>
                  <span class="pl-3 text-base">{{card.state_name}}</span>
                </p>
                  <p class="mb-3">
                  <span class="text-base text-gray-400">类型</span>
                  <span class="pl-3 text-base">{{card.card_type_name}}</span>
                </p>
            </div>
            <div v-else>
                 <el-empty :image-size="200" description="请先识别会员卡"></el-empty>
            </div>

   </div><!--1-->

    <div class="h-full pt-6 pl-6 mt-3 ml-3 shadow-lg bg-gray-50" style="width:22.8rem" >

         <div class="">

            <el-input size="small" v-model="keywords" placeholder="输入商品名称" style="width:15rem;" maxlength="30" clearable />
            <el-button  color="#626aef" plain @click="searchRecord" size="small" >查询</el-button>
            <div class="flex items-center">
             <div>

    <el-radio-group v-model="goodsClassSel" size="small"  fill="#F0AA16" @change="searchRecord">
      <el-radio label="all" >全部商品</el-radio><br/>
      <el-radio label="tc" >只看套餐</el-radio>
  </el-radio-group>

             </div>
            <el-pagination sm layout="prev, pager, next"  small="small"
            :page-size="pageSize" :current-page="currentPage" :total="total" v-if="total>0" @current-change="directPage" pager-count="3"
            > </el-pagination>
            </div>

      </div>

         <div class="overflow-auto" style="height: 24.5rem">

             <el-empty description="商品列表为空" v-if="recordList.length==0"></el-empty>

        <div
          class="flex items-center float-left p-2 mt-3 mr-3 border rounded "  style="width:21rem"
          v-for="record in recordList" :key="record.goods_id"
        >
          <div>
            <el-image
              style="width: 40px; height: 40px"
              :src="record.face_pic"
              fit="cover"
            ></el-image>
          </div>
          <div
            class="flex flex-row items-center justify-between pl-3" style="height:3.5rem"

          >
            <div class="flex flex-col justify-between h-full pb-1" style="width:10rem">
              <p class="text-base leading-none">{{ record.goods_name }}</p>
              <div>
                <el-tag size="small"
                  >{{record.unit_name}}</el-tag
                >&nbsp;
                <el-tag size="small">￥{{ record.list_price }}</el-tag>
              </div>

            </div>
              <el-input-number
                v-model="goodsValue[record.goods_id]"
                max="10000"
                min="0"
                step="1"
                :precision="0"
                size="small"
                style="width: 100px"

                @change="goodsNumChange"
              />
          </div>
        </div>
        <!--row-->
      </div>

    </div><!--2-->

    <div class="w-1/4 h-full pt-6 pl-6 mt-3 ml-3 mr-3 overflow-auto shadow-lg bg-gray-50 " >
        <p class="text-lg text-gray-700 ">提成员工</p>
        <div>
          <el-select v-model="awardUser" placeholder="请选择" size="small" class="mt-1" style="width:8rem;">
    <el-option
      v-for="item in awardList"
      :key="item.user_id"
      :value="item.user_id"
      :label="item.user_name"

    >
    </el-option>
  </el-select>
        </div>

  <p class="mt-4 text-lg text-gray-700 ">
       订单金额
  </p>
  <div>
      ￥{{totalAmount}}
  </div>

  <p class="mt-4 text-lg text-gray-700 ">
       实际金额
  </p>
  <div>
    <el-input-number v-model="realAmount" max="100000" :precision="2" size="small"  class="mt-1"  />
            &nbsp;
           <el-button @click="showNumPageFun('real')" size="small"  >小键盘</el-button>
  </div>

  <p class="mt-4 text-lg text-gray-700 ">
      有效期至
  </p>
  <div>
    <el-date-picker v-model="expiryDate" type="date" placeholder="" style="width:8.5rem;" size="small">
      </el-date-picker>
  </div>

       <div class="mt-1 overflow-auto" style="height: 5rem;">
            <el-tag
    v-for="tag in selGoods"
    :key="tag.goods_id"
    class="mx-1 my-1"
    closable
    @close="closeTagFun(tag.goods_id)"
    :type="info"
  >
    {{ tag.goods_name }}*{{tag.num}}{{tag.unit_name}}
  </el-tag>
       </div>

           <el-divider></el-divider>

        <el-button  class="" style="color: white" color="#626aef" @click="beforePublish" >确定充次</el-button>

    </div><!--3-->

  </div>

    <ScanCard @receiveScanReslut="receiveScanReslutFun" @scanCardClose="scanCardCloseFun" :disScanTypeSwitch="true" :series="false" :fromw="fromw" :showView="showScanPage">

    </ScanCard>

   <el-dialog title="" v-model="dialogResultVisible" top="2vh">

 <el-result icon="success" :title="printResult.tips" subTitle="">

      <template #extra>

              <el-descriptions column="2" >

                 <el-descriptions-item label="单号">{{printResult.bill_id}}&nbsp;</el-descriptions-item>
                 <el-descriptions-item label="时间">{{printResult.oper_time}}</el-descriptions-item>

                  <el-descriptions-item label="门店">{{printResult.branch_name}}&nbsp;{{printResult.terminal_name}}</el-descriptions-item>

                  <el-descriptions-item label="收银">{{printResult.oper_user_name}}</el-descriptions-item>

                  <el-descriptions-item label="提成">{{printResult.award_user_name}}</el-descriptions-item>

                   <el-descriptions-item label="卡号">{{printResult.relate_id}}</el-descriptions-item>


                   <el-descriptions-item label="实收">{{printResult.real_amount}}</el-descriptions-item>

                    <el-descriptions-item label="说明">{{printResult.remark}}</el-descriptions-item>
              </el-descriptions>

             <el-button type="info" size="medium" @click="printAgain">补打单据</el-button>
        <el-button type="primary" size="medium" @click="dialogResultVisible=false;router.back();">返回</el-button>
      </template>
    </el-result>

</el-dialog>

   <Keyboard :showView="showNumPage" @numCloseEvent="numCloseFun" @numConfirmEvent="numConfirmFun">

   </Keyboard>


   <Payment :showView="showPayPage" :payAmount="realAmount"  @paymentConfirmEvent="paymentConfirmEvent" @paymentCloseEvent="paymentCloseEvent">

   </Payment>



</template>
<script>
import { reactive, ref, toRefs } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import ScanCard from '../components/scanCard/index.vue'
import Keyboard from '../components/keyboard/index.vue'
import Payment from '../components/payment/index.vue'
import { getAwardUser, getPayment, noticePrint, getGoodsPage } from '@/utils/pos.js'
import { topupCoupon } from '@/utils/coupon.js'
import { localRemove } from '@/utils/index.js'

import { useRouter } from 'vue-router'
export default {
  setup () {
    const fromw = 6

    const router = useRouter()

    const dialogResultVisible = ref(false)
    const printResult = ref({})

    /*收款*/
    const paymentField=reactive({
        showPayPage:false,
        paymentConfirmEvent:(tags)=>{
          paymentField.showPayPage=false;
          doPublish(tags);
        },
        paymentCloseEvent:()=>{
paymentField.showPayPage=false;
        }
    });

    /* 扫码的 */
    const card = ref({})
    const showScanPage = ref(false)
    const receiveScanReslutFun = (cardParam) => {
      card.value = cardParam
    }
    const scanCardCloseFun = () => {
      showScanPage.value = false
    }
    const doScan = () => {
      if (card.value.card_id != '' && card.value.card_id != undefined) {
        ElMessageBox.confirm('本地已有会员卡信息，是否清空?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            card.value = {}
            showScanPage.value = true
          })
      } else {
        showScanPage.value = true
      }
    }

    /* 提成 */
    const awardList = ref([])
    const awardUser = ref('')
    const userMap = {}
    getAwardUser((userList) => {
      awardList.value = userList
      awardUser.value = userList[0].user_id
      for (let i = 0; i < userList.length; i++) {
        userMap[userList[i].user_id] = userList[i]
      }
    })


    const totalAmount=ref(0);
    const realAmount = ref(0)
    /** 小键盘 **/
    const showNumPage = ref(false)
    const numCloseFun = () => {
      showNumPage.value = false
    }

    const numConfirmFun = (val) => {
      if (tag == 'real') {
        realAmount.value = parseFloat(val)
      }
    }
    let tag = 'real'
    const showNumPageFun = (_tag) => {
      showNumPage.value = true
      tag = _tag
    }
    const beforePublish=()=>{
       if (card.value.card_id == '' || card.value.card_id == undefined) {
        ElMessage({
          showClose: true,
          message: '请先识别会员卡',
          type: 'error'
        })
        return
      }
      if(realAmount.value==0){
        doPublish([]);
      }else{
      paymentField.showPayPage=true;
      }

    };

    const doPublish = (tags) => {

      const _goodsList = []

      for (const goodsID in goodsList.selGoods) {
        _goodsList.push(goodsList.selGoods[goodsID])
      }
      if(_goodsList.length==0){
       ElMessage({
          showClose: true,
          message: '请先选择商品',
          type: 'error'
        })
        return;
      }

      ElMessageBox.confirm('是否确定提交请求？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          topupCoupon({
            total_amount:totalAmount.value,
            real_amount: realAmount.value,
            goods_list: _goodsList,
            expiry_date: goodsList.expiryDate,
            payment_list:tags,
            card_id: card.value.card_id,
            award_user_id: userMap[awardUser.value].user_id,
            award_user_name: userMap[awardUser.value].user_name
          }, (res) => {
            for (const goodsID in _goodsList) {
              goodsList.goodsValue[goodsID] = 0
            }

            goodsList.selGoods = {};
            card.value = {};
            realAmount.value = 0;
            totalAmount.value=0;
            printResult.value = res;

            dialogResultVisible.value = true

            localRemove("pay.tags");
          })
        })
    }
    const printAgain = () => {
      noticePrint(printResult.value.print_id, () => {
        ElMessage({
          showClose: true,
          message: '打印请求成功',
          type: 'success'
        })
      })
    }
    const cdate = new Date().getTime() + 365 * 24 * 60 * 60 * 1000
    // 商品
    const goodsList = reactive({
      keywords: '',
      recordList: [],
      pageSize: 4,
      currentPage: 1,
      total: 1,
      expiryDate: new Date(cdate),
      goodsClassSel: 'all',
      directPage: (idx) => {
        goodsList.currentPage = idx
        goodsList.searchRecord()
      },
      searchRecord: () => {
        getGoodsPage({
          keywords2: goodsList.goodsClassSel,
          keywords: goodsList.keywords,
          offset: goodsList.currentPage,
          limit: goodsList.pageSize

        }, (res) => {
          goodsList.total = res.total
          goodsList.recordList = res.rows
        })
      },
      goodsValue: {},
      selGoods: {},
      calcAmount: () => {
        realAmount.value = 0;
        totalAmount.value=0;
        for (const goodsID in goodsList.selGoods) {
          realAmount.value += goodsList.selGoods[goodsID].num * goodsList.selGoods[goodsID].list_price
        }
        totalAmount.value= realAmount.value;
      },
      goodsNumChange: () => {
        goodsList.recordList.forEach((goods) => {
          if (goodsList.goodsValue[goods.goods_id] != undefined &&
                  (isNaN(goodsList.goodsValue[goods.goods_id]) || goodsList.goodsValue[goods.goods_id] == 0)) {
            delete goodsList.selGoods[goods.goods_id]
          }
          if (goodsList.goodsValue[goods.goods_id] != undefined && goodsList.goodsValue[goods.goods_id] > 0) {
            goods.num = goodsList.goodsValue[goods.goods_id]
            goodsList.selGoods[goods.goods_id] = goods
          }
        })
        goodsList.calcAmount()
      },
      closeTagFun: (goodsID) => {
        goodsList.goodsValue[goodsID] = 0
        delete goodsList.selGoods[goodsID]
        goodsList.calcAmount()
      }
    })

    goodsList.searchRecord()

    return {
      printAgain,
      showScanPage,
      receiveScanReslutFun,
      scanCardCloseFun,
      showNumPageFun,
      showNumPage,
      numCloseFun,
      numConfirmFun,
      dialogResultVisible,
      realAmount,
      totalAmount,
      awardList,
      awardUser,

      fromw,
      card,
      doScan,
      doPublish,
      printResult,
      ...toRefs(goodsList),
      ...toRefs(paymentField),
      beforePublish,
      router
    }
  },
  components: { ScanCard, Keyboard,Payment }
}
</script>
<style scoped>

.active_field{
  border-color:#F0AA16;background-color:#FCF4E9;
}

</style>
